import { produce, Draft } from 'immer'
import { ID } from '../common/types';
import { Invoice } from '../common/types/invoices';
// import { InvoiceCrypt  } from '../common/types/invoicesCrypt';

type ListInvoices = Invoice[]

type State = {
  invoices: ListInvoices
  selectedInvoices: Invoice
  establishmentId: ID
  bookingFolderId: ID
}

const invoices = {
  state: {
    invoices: [],
    selectedInvoices: {},
    establishmentId: 0,
    bookingFolderId: 0
  } as State,
  reducers: {
    load: produce((draft: Draft<State>, payload: ListInvoices) => {
      draft.invoices = payload;
    }),
    updateSelectedInvoices: produce((draft: Draft<State>, payload: Partial<State>) => {
      let filteredInvoices = draft.invoices.filter(invoice => {
        return invoice.bookingFolderId === payload;
      });

      Object.assign(draft.invoices,filteredInvoices[0]);

      draft.bookingFolderId = payload.bookingFolderId;
      draft.establishmentId = payload.establishmentId;
    }),
  },
  effects: (dispatch) => ({
  })
}

export default invoices